import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { ReactElement, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import styles from './collection.module.scss';
import ShareButton from './ShareButton';

import { ReactComponent as IconChecker } from '../../../../../assets/images/checker.svg';
import { ReactComponent as InfoIcon } from '../../../../../assets/images/info.svg';

import { ProductInfoModel } from '../../../../../models/request.model';
import {
    clearCollection,
    collectionData,
    collectionProductsNotices,
    collectionProductsData,
} from '../../../../../store/collection';
import { setFactSheetPDF, setFactSheetXLSX } from '../../../../../store/location';
import { togglePopup } from '../../../../../store/ui';
import { useMedia } from '../../../../context/InterfaceContext';
import Button, { ButtonKind } from '../../button/Button';
import DownloadFactSheet from '../../downloadFactsheet';
import Product from '../../product';

const CollectionList = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const productsData = useSelector(collectionProductsData);
    const collection = useSelector(collectionData);
    const noticesList = useSelector(collectionProductsNotices);
    const { isMobile, isMobileMiddle } = useMedia();

    useEffect(() => {
        dispatch(setFactSheetPDF(''));
        dispatch(setFactSheetXLSX(''));
    }, [dispatch, productsData]);

    if (!isEmpty(productsData)) {
        const products: ReactElement[] = [];
        const request: ProductInfoModel[] = [];

        let capable = false;
        productsData.forEach(item => {
            products.push(<Product key={item.producturn} product={item} horizontalMode removable collectionStyling />);
            request.push({
                urn: item.producturn,
                format: item.format,
                address: item.address,
                id: item.mediainfo.nummer,
                requestofferbutton: item.requestofferbutton,
            });
            capable = capable || !!item.sujetcheckinformation;
        });
        const sujetCheckCapable = products.length > 0 && capable && products.length <= 50;

        return (
            <div className={styles.collectionList}>
                <div className={'error__container'}>
                    {noticesList &&
                        noticesList.map(({ message, code }) => (
                            <div key={`notice-container-${code}`} className={classNames('errorContainer notices')}>
                                <InfoIcon width={20} height={20} />
                                <p>{message}</p>
                            </div>
                        ))}
                </div>
                <div className={styles.productList}>{products}</div>
                <div className={styles.collectionRow}>
                    <Button
                        kind={ButtonKind.LINK}
                        onClick={() => dispatch(clearCollection())}
                        className={styles.clearAllBtn}
                    >
                        {intl.formatMessage({ id: 'collection.clearButton', defaultMessage: 'Löschen' })}
                    </Button>

                    <div className={styles.shareDownload}>
                        <ShareButton isHideText={isMobileMiddle || isMobile} />
                        <DownloadFactSheet
                            urns={collection}
                            isFactSheetLabel={false}
                            isHideText={isMobileMiddle || isMobile}
                        />
                        <Button
                            kind={ButtonKind.LINK}
                            // kind={isFactSheetLabel ? ButtonKind.LINK : ButtonKind.INVERT_GRAY}
                            onClick={() => {
                                dispatch(
                                    togglePopup({ name: 'sujet_upload_and_check', status: true, payload: productsData })
                                );
                            }}
                            disabled={!sujetCheckCapable}
                            className={styles.shareBtn}
                        >
                            <IconChecker />
                            {!isMobileMiddle &&
                                !isMobile &&
                                ' ' +
                                    intl.formatMessage({
                                        id: 'sujetCheck.title',
                                        defaultMessage: 'Sujetcheck',
                                    })}
                        </Button>
                    </div>

                    <Button
                        kind={isMobile || isMobileMiddle ? ButtonKind.INVERT : ButtonKind.PRIMARY}
                        onClick={() => {
                            dispatch(togglePopup({ name: 'location_request_spaces', status: true, payload: request }));
                        }}
                    >
                        {intl.formatMessage({ id: 'collection.requestButton', defaultMessage: 'Anfragen' })}
                    </Button>
                </div>
            </div>
        );
    }

    return null;
};

export default CollectionList;
